export default __webpack_public_path__ + "images/hr-dotted.png?4758c547b103aba58214d1de4a3c2755";